import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import DirectoryPage from "@/pages/DirectoryPage";
import ProfilePage from "@/pages/ProfilePage";
import AboutPage from "@/pages/AboutPage";
import OpenProblemsPage from "@/pages/OpenProblemsPage";
import ProblemDetailPage from "@/pages/ProblemDetailPage";
import ClosedProblemsPage from "@/pages/ClosedProblemsPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import MyProfilePage from "@/pages/MyProfilePage";
import BrowseTagPage from "@/pages/BrowseTagPage";

function AppRouter() {
  const location = useLocation();
  // Intercept the OAuth callback: session_id arrives in the URL fragment.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<DirectoryPage />} />
        <Route path="/people/:id" element={<ProfilePage />} />
        <Route path="/problems" element={<OpenProblemsPage />} />
        <Route path="/problems/:id" element={<ProblemDetailPage />} />
        <Route path="/closed-problems" element={<ClosedProblemsPage />} />
        <Route path="/browse" element={<Navigate to="/closed-problems" replace />} />
        <Route path="/tools/:name" element={<BrowseTagPage mode="tool" />} />
        <Route path="/categories/:name" element={<BrowseTagPage mode="category" />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/my/profile" element={<MyProfilePage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#FAFAFA] text-[#111827] font-body">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
